import React from 'react';

import Switch from '../../../forms/Switch';

export default function GenerateATag() {
  return <Switch label="Generate Click Tag" name="generateATag" />;
}
